import { FormKey } from '../enums/formKey';
import { StepKey } from '../enums/stepKey';

/**
 * The name of the key is session storage where we persist the app state.
 */
export const STORAGE_KEY = 'app-session';
/**
 * The number of minutes after which we consider a session to be expired.
 * This is used to determine whether to load a persisted session or start fresh.
 */
export const SESSION_EXPIRY_MINUTES = 55;
/**
 * The app form fields
 */
export const requiredFormFields = {
  [StepKey.APPLIANCE_DETAILS]: [FormKey.SUPER_CATEGORY, FormKey.ITEM_CATEGORY],
  [StepKey.MODEL_SERIAL]: [FormKey.MODEL_NUMBER, FormKey.SERIAL_NUMBER],
  [StepKey.PURCHASE_PRICE]: [FormKey.PURCHASE_PRICE],
  [StepKey.ARRIVAL_DATE]: [FormKey.ARRIVAL_DATE],
  [StepKey.PERSONAL_DETAILS]: [
    FormKey.FIRST_NAME,
    FormKey.LAST_NAME,
    FormKey.EMAIL,
    FormKey.PHONE_NUMBER,
    FormKey.ADDRESS_LINE_1,
    FormKey.CITY,
    FormKey.STATE_CODE,
    FormKey.POSTAL_CODE,
    FormKey.IS_VALID,
    FormKey.ADDRESS_ID,
    FormKey.MERCHANDISE_ADDRESS_LINE_1,
    FormKey.MERCHANDISE_CITY,
    FormKey.MERCHANDISE_STATE_CODE,
    FormKey.MERCHANDISE_POSTAL_CODE,
    FormKey.MERCHANDISE_IS_VALID,
    FormKey.MERCHANDISE_ADDRESS_ID,
  ],
};
